/* Schematics based on Category Index */
import BUCK_CONTROLLER from '../../../images/schematic/buck_controller.svg';
import BUCK_ASYNC_INT_MOSFET from '../../../images/schematic/buck_async_int_mosfet.svg';
import BUCK_ASYNC_INT_MOSFET_IC_FLOATING_GND from '../../../images/schematic/buck_async_int_mosfet_ic_floating_gnd.svg';
import BUCK_CONVERTER from '../../../images/schematic/buck_converter.svg';
import BUCK_CONVERTER_DIGITAL from '../../../images/schematic/buck_converter_digital.svg';
import BOOST_ASYNC_EXT_MOSFET from '../../../images/schematic/boost_async_ext_mosfet.svg';
import BOOST_ASYNC_EXT_MOSFET_VCC_IS_VIN from '../../../images/schematic/boost_async_ext_mosfet_vcc_is_vin.svg';
import BOOST_ASYNC_INT_MOSFET from '../../../images/schematic/boost_async_int_mosfet.svg';
import BOOST_CONVERTER_NMOS from '../../../images/schematic/boost_converter_nmos.svg';
import BOOST_CONVERTER_PMOS from '../../../images/schematic/boost_converter_pmos.svg';
import FLYBACK_CONTROLLER_AC_PSR from '../../../images/schematic/flyback_controller_ac_psr.svg';
import FLYBACK_CONTROLLER_AC_SSR from '../../../images/schematic/flyback_controller_ac_ssr.svg';
import FLYBACK_CONTROLLER_DC_PSR from '../../../images/schematic/flyback_controller_dc_psr.svg';
import FLYBACK_CONTROLLER_DC_SSR from '../../../images/schematic/flyback_controller_dc_ssr.svg';
import FLYBACK_ASYNC_INT_MOSFET_AC_PSR from '../../../images/schematic/flyback_async_int_mosfet_ac_psr.svg';
import FLYBACK_ASYNC_INT_MOSFET_AC_SSR from '../../../images/schematic/flyback_async_int_mosfet_ac_ssr.svg';
import FLYBACK_ASYNC_INT_MOSFET_DC_PSR from '../../../images/schematic/flyback_async_int_mosfet_dc_psr.svg';
import FLYBACK_ASYNC_INT_MOSFET_DC_SSR from '../../../images/schematic/flyback_async_int_mosfet_dc_ssr.svg';
import FLYBACK_CONTROLLER_AC_PSR_NEG from '../../../images/schematic/flyback_controller_ac_psr_neg.svg';
import FLYBACK_CONTROLLER_AC_SSR_NEG from '../../../images/schematic/flyback_controller_ac_ssr_neg.svg';
import FLYBACK_CONTROLLER_DC_PSR_NEG from '../../../images/schematic/flyback_controller_dc_psr_neg.svg';
import FLYBACK_CONTROLLER_DC_SSR_NEG from '../../../images/schematic/flyback_controller_dc_ssr_neg.svg';
import FLYBACK_ASYNC_INT_MOSFET_AC_PSR_NEG from '../../../images/schematic/flyback_async_int_mosfet_ac_psr_neg.svg';
import FLYBACK_ASYNC_INT_MOSFET_AC_SSR_NEG from '../../../images/schematic/flyback_async_int_mosfet_ac_ssr_neg.svg';
import FLYBACK_ASYNC_INT_MOSFET_DC_PSR_NEG from '../../../images/schematic/flyback_async_int_mosfet_dc_psr_neg.svg';
import FLYBACK_ASYNC_INT_MOSFET_DC_SSR_NEG from '../../../images/schematic/flyback_async_int_mosfet_dc_ssr_neg.svg';
import CHARGE_PUMP_NEGATIVE_0_DIODES from '../../../images/schematic/charge_pump_negative_0_diodes.svg';
import CHARGE_PUMP_NEGATIVE_2_DIODES from '../../../images/schematic/charge_pump_negative_2_diodes.svg';
import CHARGE_PUMP_NEGATIVE_4_DIODES from '../../../images/schematic/charge_pump_negative_4_diodes.svg';
import CHARGE_PUMP_POSITIVE_0_DIODES from '../../../images/schematic/charge_pump_positive_0_diodes.svg';
import CHARGE_PUMP_POSITIVE_2_DIODES from '../../../images/schematic/charge_pump_positive_2_diodes.svg';
import CHARGE_PUMP_POSITIVE_4_DIODES from '../../../images/schematic/charge_pump_positive_4_diodes.svg';
import LDO_FIXED from '../../../images/schematic/ldo_FIX_nEN.svg';
import LDO_FIXED_EN from '../../../images/schematic/ldo_FIX_EN.svg';
import LDO_FIXED_BIAS from '../../../images/schematic/ldo_FIX_BIAS_nEN.svg';
import LDO_FIXED_BIAS_EN from '../../../images/schematic/ldo_FIX_BIAS_EN.svg';
import LDO_ADJ from '../../../images/schematic/ldo_ADJ_nEN_nCff.svg';
import LDO_ADJ_EN from '../../../images/schematic/ldo_ADJ_EN_nCff.svg';
import LDO_ADJ_BIAS from '../../../images/schematic/ldo_ADJ_BIAS_nEN_nCff.svg';
import LDO_ADJ_BIAS_EN from '../../../images/schematic/ldo_ADJ_BIAS_EN_nCff.svg';
import LDO_ADJ_INCLCFF from '../../../images/schematic/ldo_ADJ_nEN_Cff.svg';
import LDO_ADJ_INCLCFF_EN from '../../../images/schematic/ldo_ADJ_EN_Cff.svg';
import LDO_ADJ_BIAS_INCLCFF from '../../../images/schematic/ldo_ADJ_BIAS_nEN_Cff.svg';
import LDO_ADJ_BIAS_INCLCFF_EN from '../../../images/schematic/ldo_ADJ_BIAS_EN_Cff.svg';
import LDO_NEG_FIXED from '../../../images/schematic/ldo_NEG_FIX_nEN.svg';
import LDO_NEG_FIXED_EN from '../../../images/schematic/ldo_NEG_FIX_EN.svg';
import LDO_ADJ_FLOAT from '../../../images/schematic/ldo_FLOAT_ADJ_nEN_nCff.svg';
import LDO_ADJ_FLOAT_EN from '../../../images/schematic/ldo_FLOAT_ADJ_EN_nCff.svg';
import LDO_ADJ_FLOAT_INCLCADJ from '../../../images/schematic/ldo_FLOAT_ADJ_nEN_Cff.svg';
import LDO_ADJ_FLOAT_INCLCADJ_EN from '../../../images/schematic/ldo_FLOAT_ADJ_EN_Cff.svg';
import LDO_NEG_ADJ_FLOAT from '../../../images/schematic/ldo_NEG_FLOAT_ADJ_nEN_nCff.svg';
import LDO_NEG_ADJ_FLOAT_EN from '../../../images/schematic/ldo_NEG_FLOAT_ADJ_EN_nCff.svg';
import INVERTING_BUCK_BOOST from '../../../images/schematic/inverting_buck_boost.svg';

import i18n from '../../../utils/i18n';
import { COMPONENTS } from './components';

export const SCHEMATICS = {
	BUCK_CONTROLLER: {
		svg: BUCK_CONTROLLER,
		components: [COMPONENTS.IC, COMPONENTS.HS, COMPONENTS.LS, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout],
		note: ''
	},
	BUCK_ASYNC_INT_MOSFET: {
		svg: BUCK_ASYNC_INT_MOSFET,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout, COMPONENTS.Dout],
		note: ''
	},
	BUCK_ASYNC_INT_MOSFET_IC_FLOATING_GND: {
		svg: BUCK_ASYNC_INT_MOSFET_IC_FLOATING_GND,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout, COMPONENTS.Dout],
		note: ''
	},
	BUCK_CONVERTER: {
		svg: BUCK_CONVERTER,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout],
		note: ''
	},
	BUCK_CONVERTER_DIGITAL: {
		svg: BUCK_CONVERTER_DIGITAL,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout],
		note: i18n.t('components.schematic.constants.notes.bcd')
	},
	BOOST_ASYNC_EXT_MOSFET: {
		svg: BOOST_ASYNC_EXT_MOSFET,
		components: [
			COMPONENTS.IC,
			// COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Lout,
			COMPONENTS.Dout,
			COMPONENTS.Q
		],
		note: ''
	},
	BOOST_ASYNC_EXT_MOSFET_VCC_IS_VIN: {
		svg: BOOST_ASYNC_EXT_MOSFET_VCC_IS_VIN,
		components: [
			COMPONENTS.IC,
			// COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Lout,
			COMPONENTS.Dout,
			COMPONENTS.Q
		],
		note: ''
	},
	BOOST_ASYNC_INT_MOSFET: {
		svg: BOOST_ASYNC_INT_MOSFET,
		components: [
			COMPONENTS.IC,
			// COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Lout,
			COMPONENTS.Dout
		],
		note: ''
	},
	BOOST_CONVERTER_NMOS: {
		svg: BOOST_CONVERTER_NMOS,
		components: [
			COMPONENTS.IC,
			// COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Lout
		],
		note: ''
	},
	BOOST_CONVERTER_PMOS: {
		svg: BOOST_CONVERTER_PMOS,
		components: [
			COMPONENTS.IC,
			// COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Lout
		],
		note: ''
	},
	FLYBACK_CONTROLLER_AC_PSR: {
		svg: FLYBACK_CONTROLLER_AC_PSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_AC_SSR: {
		svg: FLYBACK_CONTROLLER_AC_SSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_DC_PSR: {
		svg: FLYBACK_CONTROLLER_DC_PSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_DC_SSR: {
		svg: FLYBACK_CONTROLLER_DC_SSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_AC_PSR: {
		svg: FLYBACK_ASYNC_INT_MOSFET_AC_PSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_AC_SSR: {
		svg: FLYBACK_ASYNC_INT_MOSFET_AC_SSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_DC_PSR: {
		svg: FLYBACK_ASYNC_INT_MOSFET_DC_PSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_DC_SSR: {
		svg: FLYBACK_ASYNC_INT_MOSFET_DC_SSR,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_AC_PSR_NEG: {
		svg: FLYBACK_CONTROLLER_AC_PSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_AC_SSR_NEG: {
		svg: FLYBACK_CONTROLLER_AC_SSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_DC_PSR_NEG: {
		svg: FLYBACK_CONTROLLER_DC_PSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_CONTROLLER_DC_SSR_NEG: {
		svg: FLYBACK_CONTROLLER_DC_SSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.Q,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Rs,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_AC_PSR_NEG: {
		svg: FLYBACK_ASYNC_INT_MOSFET_AC_PSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_AC_SSR_NEG: {
		svg: FLYBACK_ASYNC_INT_MOSFET_AC_SSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cdc,
			COMPONENTS.Rsn,
			COMPONENTS.D1,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_DC_PSR_NEG: {
		svg: FLYBACK_ASYNC_INT_MOSFET_DC_PSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	FLYBACK_ASYNC_INT_MOSFET_DC_SSR_NEG: {
		svg: FLYBACK_ASYNC_INT_MOSFET_DC_SSR_NEG,
		components: [
			COMPONENTS.IC,
			COMPONENTS.ICiso,
			COMPONENTS.T,
			COMPONENTS.Cout,
			COMPONENTS.Csn,
			COMPONENTS.Cin,
			COMPONENTS.Rsn,
			COMPONENTS.Dout,
			COMPONENTS.Dsn
		],
		note: ''
	},
	CHARGE_PUMP_NEGATIVE_0_DIODES: {
		svg: CHARGE_PUMP_NEGATIVE_0_DIODES,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.C1],
		note: ''
	},
	CHARGE_PUMP_NEGATIVE_2_DIODES: {
		svg: CHARGE_PUMP_NEGATIVE_2_DIODES,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.C1,
			COMPONENTS.C2,
			COMPONENTS.C3,
			COMPONENTS.D1,
			COMPONENTS.D2
		],
		note: i18n.t('components.schematic.constants.notes.cpn2d')
	},
	CHARGE_PUMP_NEGATIVE_4_DIODES: {
		svg: CHARGE_PUMP_NEGATIVE_4_DIODES,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.C1,
			COMPONENTS.C2,
			COMPONENTS.C3,
			COMPONENTS.C4,
			COMPONENTS.C5,
			COMPONENTS.D1,
			COMPONENTS.D2,
			COMPONENTS.D3,
			COMPONENTS.D4
		],
		note: i18n.t('components.schematic.constants.notes.cpn4d')
	},
	CHARGE_PUMP_POSITIVE_0_DIODES: {
		svg: CHARGE_PUMP_POSITIVE_0_DIODES,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.C1],
		note: ''
	},
	CHARGE_PUMP_POSITIVE_2_DIODES: {
		svg: CHARGE_PUMP_POSITIVE_2_DIODES,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.C1, COMPONENTS.D1, COMPONENTS.D2],
		note: i18n.t('components.schematic.constants.notes.cpp2d')
	},
	CHARGE_PUMP_POSITIVE_4_DIODES: {
		svg: CHARGE_PUMP_POSITIVE_4_DIODES,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.C1,
			COMPONENTS.C2,
			COMPONENTS.C3,
			COMPONENTS.D1,
			COMPONENTS.D2,
			COMPONENTS.D3,
			COMPONENTS.D4
		],
		note: i18n.t('components.schematic.constants.notes.cpp4d')
	},
	LDO_FIXED: {
		svg: LDO_FIXED,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout],
		note: ''
	},
	LDO_FIXED_EN: {
		svg: LDO_FIXED_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout],
		note: ''
	},
	LDO_FIXED_BIAS: {
		svg: LDO_FIXED_BIAS,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cbias],
		note: ''
	},
	LDO_FIXED_BIAS_EN: {
		svg: LDO_FIXED_BIAS_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cbias],
		note: ''
	},
	LDO_ADJ: {
		svg: LDO_ADJ,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_EN: {
		svg: LDO_ADJ_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_BIAS: {
		svg: LDO_ADJ_BIAS,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cbias, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_BIAS_EN: {
		svg: LDO_ADJ_BIAS_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cbias, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_FLOAT: {
		svg: LDO_ADJ_FLOAT,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	LDO_ADJ_FLOAT_EN: {
		svg: LDO_ADJ_FLOAT_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	LDO_ADJ_INCLCFF: {
		svg: LDO_ADJ_INCLCFF,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cff, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_INCLCFF_EN: {
		svg: LDO_ADJ_INCLCFF_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cff, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: ''
	},
	LDO_ADJ_BIAS_INCLCFF: {
		svg: LDO_ADJ_BIAS_INCLCFF,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Cbias,
			COMPONENTS.Cff,
			COMPONENTS.Rbot,
			COMPONENTS.Rtop
		],
		note: ''
	},
	LDO_ADJ_BIAS_INCLCFF_EN: {
		svg: LDO_ADJ_BIAS_INCLCFF_EN,
		components: [
			COMPONENTS.IC,
			COMPONENTS.Cin,
			COMPONENTS.Cout,
			COMPONENTS.Cbias,
			COMPONENTS.Cff,
			COMPONENTS.Rbot,
			COMPONENTS.Rtop
		],
		note: ''
	},
	LDO_ADJ_FLOAT_INCLCADJ: {
		svg: LDO_ADJ_FLOAT_INCLCADJ,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cadj, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	LDO_ADJ_FLOAT_INCLCADJ_EN: {
		svg: LDO_ADJ_FLOAT_INCLCADJ_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Cadj, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	LDO_NEG_FIXED: {
		svg: LDO_NEG_FIXED,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout],
		note: ''
	},
	LDO_NEG_FIXED_EN: {
		svg: LDO_NEG_FIXED_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout],
		note: ''
	},
	LDO_NEG_ADJ_FLOAT: {
		svg: LDO_NEG_ADJ_FLOAT,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	LDO_NEG_ADJ_FLOAT_EN: {
		svg: LDO_NEG_ADJ_FLOAT_EN,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Rbot, COMPONENTS.Rtop],
		note: i18n.t('components.schematic.constants.notes.ldo')
	},
	INVERTING_BUCK_BOOST: {
		svg: INVERTING_BUCK_BOOST,
		components: [COMPONENTS.IC, COMPONENTS.Cin, COMPONENTS.Cout, COMPONENTS.Lout],
		note: i18n.t('components.schematic.constants.notes.ibb')
	}
};
